import { Divider, IconButton, Tooltip } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material';
import React, { useEffect, useState } from 'react'
import CustomDropdown from '../../Common/CustomDropdown';
import { FileQuestion, List, Plus } from 'lucide-react';
import CustomInput from '../../Common/CustomInput';
import { Button } from '../../Common/Button';
import QuestionBox from '../../Common/QuestionBox';
import { ACTIONS } from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { dynamicSequence } from '../../helper/dynamicSequence';
import { path } from '../../Utils/ScreenPath';
import Exam from '../../assets/images/Exam.png';
import { Modal } from '../../Common/Modal';
import QuestionShow from '../../Common/QuestionShow';

const Section = ({ section, sectionIndex }) => {
    const dispatch = useDispatch();
    const navigat = useNavigate();
    const [errors, setErrors] = useState([]);
    const selectedData = useSelector((state) => state?.SelectedDetail?.Data);
    const noticeData = useSelector((state) => state?.Notice?.NoticeData?.data || {});

    const [isModelOpen, setIsModelOpen] = useState(false);
    const [isReportModelOpen, setIsReportModelOpen] = useState(false);
    const [queReportData, setQueReportData] = useState({});
    const [qusetionNumber, setQusetionNumber] = useState(0);
    const [sectionId, setSectionId] = useState(null)
    const [divisionId, setDivisionId] = useState(null);



    const handleAddDivision = (sectionIndex) => {
        const newDivision = {
            division_id: selectedData?.sections_info?.[sectionIndex]?.divisions?.length + 1,
            marks: 0,
            random_genrate_notice: "",
            question_data: [],
        };

        const sections_info = selectedData?.sections_info?.map((section, i) => {
            if (i === sectionIndex) {
                return { ...section, divisions: [...section?.divisions, newDivision] }
            } else {
                return section
            }
        })
        dispatch(ACTIONS.getSelectedData({ ...selectedData, sections_info }))
    }

    const validateFields = (sectionIndex, divisionIndex) => {
        const divisions = selectedData?.sections_info?.[sectionIndex]?.divisions?.[divisionIndex];
        const newErrors = [...errors]; // Copy errors array

        // Initialize error object for the specific divisions if not already present
        newErrors[divisionIndex] = newErrors[divisionIndex] || {};

        // Check if marks and random_genrate_notice are filled
        newErrors[divisionIndex].marks = !divisions?.marks || divisions.marks <= 0
            ? 'Marks are required and should be greater than 0'
            : '';

        newErrors[divisionIndex].random_genrate_notice = !divisions?.random_genrate_notice
            ? 'Notice title is required'
            : '';

        setErrors(newErrors);

        // Return true if there are no errors in the divisions
        return !newErrors[divisionIndex].marks && !newErrors[divisionIndex].random_genrate_notice;
    };

    const handleAddQuestion = (sectionIndex, divisionIndex) => {
        if (validateFields(sectionIndex, divisionIndex)) {
            navigat(path.QTypeWise + `/${sectionIndex}/${divisionIndex}`);
        } else {
        }
    };

    const handleRemoveSection = (sectionIndex) => {
        const data = selectedData?.sections_info?.filter((section, i) => i !== sectionIndex)
        const sections_info = data?.map((section, i) => {
            section = { ...section, "section_name": `Section ${String.fromCharCode(65 + i)}`, "section_id": i + 1 }
            return section
        })
        dispatch(ACTIONS.getSelectedData({ ...selectedData, sections_info }))
    }

    const handleRemoveDivision = (sectionIndex, divisionIndex) => {
        const sections_info = selectedData?.sections_info?.map((section, i) => {
            if (i === sectionIndex) {
                if (section?.divisions?.length === 1) {
                    return section
                }
                const updatedDivisions = section?.divisions?.filter((divisions, j) => j !== divisionIndex);
                const reassignedDivisions = updatedDivisions?.map((divisions, index) => ({
                    ...divisions,
                    division_id: index + 1
                }));
                return { ...section, divisions: reassignedDivisions };
            } else {
                return section
            }
        })

        dispatch(ACTIONS.getSelectedData({ ...selectedData, sections_info }))
    }

    const handleDivisionChange = (sectionIndex, divisionIndex, name, value) => {
        if (name === "marks" && (value < 0 || value > 999)) { return }

        const sections_info = selectedData?.sections_info?.map((section, i) => {
            if (i === sectionIndex) {
                return {
                    ...section, divisions: section?.divisions?.map((divisions, j) => {
                        if (j === divisionIndex) {
                            return { ...divisions, [name]: value?.label || value }
                        } else {
                            return divisions
                        }
                    })
                }
            } else {
                return section
            }
        })
        dispatch(ACTIONS.getSelectedData({ ...selectedData, sections_info }))
    }
    const handleQuestionRemove = (sectionIndex, divisionIndex, mainItem) => {

        const updatedSections = selectedData.sections_info.map(
            section => {
                if (
                    section?.section_id === Number(sectionIndex) + 1
                ) {
                    const updatedDivisions = section?.divisions.map(
                        division => {

                            if (division?.division_id === Number(divisionIndex) + 1) {
                                const updatedQuestionData =
                                    division?.question_data
                                        .filter(
                                            question =>
                                                question?.id !== mainItem?.id,
                                        )
                                        .map((question, newIndex) => ({
                                            ...question,
                                            question_id: newIndex + 1,
                                        }));

                                return {
                                    ...division,
                                    question_data: updatedQuestionData,
                                };
                            }
                            return division;
                        },
                    );
                    return {
                        ...section,
                        divisions: updatedDivisions,
                    };
                }
                return section;
            },
        );

        let dataObject = dynamicSequence(updatedSections);

        const finalPayload = {
            ...selectedData,
            sections_info: dataObject,
        };

        dispatch(ACTIONS.getSelectedData(finalPayload))
    }

    const handleQuestionClick = (sectionIndex, question_number, mainItem, divisionIndex) => {

        setQueReportData(mainItem);
        setQusetionNumber(question_number);
        setSectionId(sectionIndex);
        setDivisionId(divisionIndex);
        setIsReportModelOpen(true);
    }

    const handleModelApply = () => {
        const data = selectedData?.sections_info?.map((section, i) => {
            section = { ...section, "section_name": `Section ${String.fromCharCode(65 + i)}`, "section_id": i + 1 }
            return section
        })
        dispatch(ACTIONS.getSelectedData({ ...selectedData, sections_info: data }))
        setIsModelOpen(!isModelOpen);
    }

    const handleModelClose = () => {
        setIsModelOpen(!isModelOpen);
    }

    return (
        <div style={{ padding: "8px", margin: "8px", backgroundColor: "white", borderRadius: "15px" }}>
            {true &&
                <div style={{ padding: "10px" }}>
                    {selectedData?.genrate_type?.toLowerCase() == "with section" &&
                        <>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                                <h4 className="text-lg font-semibold">
                                    {section?.section_name}
                                </h4>
                                <IconButton onClick={() => handleRemoveSection(sectionIndex)}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            <Divider />
                        </>}
                    {section?.divisions?.map((item, divisionIndex) => {
                        return (
                            <div>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', paddingTop: '20px' }}>
                                    <h2 className="font-medium">
                                        {`Division ${String.fromCharCode(65 + divisionIndex)}`}
                                    </h2>
                                    <IconButton onClick={() => handleRemoveDivision(sectionIndex, divisionIndex)}>
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                                {/* <h1>Ankit</h1> */}
                                <div className='w-full flex flex-col lg:flex-row items-center justify-around  gap-5'>
                                    {selectedData?.genrate_type?.toLowerCase() != "with section" &&
                                        <div className="w-full">
                                            <CustomInput
                                                type="text"
                                                label="Question Title"
                                                placeholder="Enter Title"
                                                value={item?.questionTitle}
                                                onChange={(value) => handleDivisionChange(sectionIndex, divisionIndex, "questionTitle", value)}
                                                icon={<img src={Exam} alt="Exam Icon" className="w-5 h-5" />}
                                            />
                                            {errors[divisionIndex]?.questionTitle && (
                                                <span style={{ color: 'red', fontSize: '12px' }}>{errors[divisionIndex]?.questionTitle}</span>
                                            )}
                                        </div>}
                                    <div className="w-full">
                                        <CustomDropdown
                                            title="Question Title Name"
                                            data={noticeData?.[0]?.noticeInfo || []}
                                            textKey="label"
                                            onSelect={(e) => handleDivisionChange(sectionIndex, divisionIndex, "random_genrate_notice", e)}
                                            defaultValue={item?.random_genrate_notice}
                                            icon={<FileQuestion />}
                                        />
                                        {errors[divisionIndex]?.random_genrate_notice && (
                                            <span style={{ color: 'red', fontSize: '12px' }}>{errors[divisionIndex]?.random_genrate_notice}</span>
                                        )}
                                    </div>
                                    <div className="w-full">
                                        <CustomInput
                                            type="number"
                                            label="Marks"
                                            placeholder="Enter Marks"
                                            value={item?.marks}
                                            onChange={(value) => handleDivisionChange(sectionIndex, divisionIndex, "marks", value)}
                                            icon={<List />}
                                        />
                                        {errors[divisionIndex]?.marks && (
                                            <span style={{ color: 'red', fontSize: '12px' }}>{errors[divisionIndex]?.marks}</span>
                                        )}
                                    </div>
                                    <div className='w-full flex flex-col xl:flex-row items-center justify-around  xl:gap-5 gap-1'>
                                        {section.divisions.length - 1 === divisionIndex && <Button
                                            id=""
                                            isBordered="true"
                                            type="button"
                                            label={"Add Division"}
                                            icon={<Plus />}
                                            onClick={() => { handleAddDivision(sectionIndex) }}
                                        />}
                                        <Button
                                            id=""
                                            isBordered="true"
                                            type="button"
                                            label={"Add Question"}
                                            icon={<Plus />}
                                            onClick={() => { handleAddQuestion(sectionIndex, divisionIndex) }}
                                        />
                                    </div>
                                </div>
                                <div className="py-1 flex flex-wrap gap-2 justify-between md:justify-start">
                                    {item?.question_data?.length > 0 &&
                                        item?.question_data.map((item, questionIndex) => {

                                            const alphabetLetter = item?.andId ? String.fromCharCode(97 + (item?.andId - 1 || 0)) : ''

                                            return (
                                                <QuestionBox
                                                    onQueClick={() => handleQuestionClick(sectionIndex, item?.question_id, item, divisionIndex)}
                                                    onRemove={() => handleQuestionRemove(sectionIndex, divisionIndex, item)}
                                                    bgColor={item?.andId > 0 ? "#3BC55D" : item?.isOr ? "#FF8C04" : "#F6F7F9"}>
                                                    {item?.question_id && <span>Q.{String(item?.question_id)?.padStart(2, "0")}</span>}
                                                    <span style={{ marginRight: alphabetLetter ? '0px' : '16px' }}>{alphabetLetter ? ` (${alphabetLetter})` : ''}</span>
                                                </QuestionBox>
                                            )
                                        })
                                    }
                                </div>




                            </div>
                        )
                    })}
                </div>}
            <QuestionShow
                isModelOpen={isReportModelOpen}
                setIsPurchaseModelOpen={setIsReportModelOpen}
                queReportData={queReportData}
                qusetionNumber={qusetionNumber}
                sectionId={sectionId}
                divisionId={divisionId}
            // remove={() => handleQuestionClick(sectionIndex, item?.question_id, item, divisionIndex)}
            />
        </div>
    )
}

export default Section  
